import { createApp } from 'vue'
import App from './App.vue'
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import router from "./js/router/router";
import Api from "./js/api";
import Store from "./js/store/store";
import dayjs from "dayjs";
// 引入中文包
import "dayjs/locale/zh-cn";

const app = createApp(App);
app.config.globalProperties.$Api = Api;
app.config.globalProperties.$Store = Store;
app.config.globalProperties.$dayjs = dayjs;
app.use(Antd).use(router).mount("#app");
